import { render } from "./LoginBlackCentered.vue?vue&type=template&id=65d28c49"
import script from "./LoginBlackCentered.vue?vue&type=script&lang=js"
export * from "./LoginBlackCentered.vue?vue&type=script&lang=js"

import "./LoginBlackCentered.vue?vue&type=style&index=0&id=65d28c49&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__